import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useGlobals } from 'hooks/useGlobals';
import { useSendTracking } from 'hooks/useSendTracking';
import { useTruckerProps } from 'hooks/useTruckerProps';

const useBlockedProfileEvents = () => {
  const { eventsSource, freightId, truckerSearchedBy, truckerId } = useTruckerProps();
  const globals = useGlobals();

  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();

  const getCompanyId = () => globals?.user?.data?.company?.id;

  const requestAccessOnBlurEvent = () => {
    const companyId = getCompanyId();

    sendAmplitude('trucker_profile_access_interest_blur', {
      source: eventsSource,
      companyId,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_access_interest_blur',
        data: {
          source: eventsSource,
          companyId: `hashed|${companyId}`,
        },
      },
      'trucker_profile'
    );
  };

  const requestAccessOnButtonEvent = () => {
    const companyId = getCompanyId();

    const commomData = {
      source: eventsSource,
      type: truckerSearchedBy || textConstants.notAvailaible,
    };

    sendAmplitude('trucker_profile_access_interest', {
      ...commomData,
      freightId: freightId || textConstants.notAvailaible,
      companyId,
      truckerId,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_access_interest',
        data: {
          ...commomData,
          freightId: freightId ? `hashed|${freightId}` : textConstants.notAvailaible,
          companyId: `hashed|${companyId}`,
          truckerId: `hashed|${truckerId}`,
        },
      },
      'trucker_profile'
    );
  };

  return { requestAccessOnButtonEvent, requestAccessOnBlurEvent };
};

export default useBlockedProfileEvents;
